// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salon-benchmark {
  min-width: 0;
  border: 1px solid var(--lkfr-border, #e0e5ee);
  border-radius: 18px;
  background: #fff;
  padding: 20px;
  color: var(--lkfr-ink, #252238);
  margin: 18px 0;
  box-sizing: border-box;
}
.salon-benchmark * {
  box-sizing: border-box;
}
.salon-benchmark button {
  font: inherit;
  cursor: pointer;
}
.salon-benchmark p {
  line-height: 1.5;
}
.salon-benchmark .benchmark-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.salon-benchmark .benchmark-header h2 {
  font-size: 22px;
  margin: 6px 0;
  font-weight: 600;
}
.salon-benchmark .benchmark-header h2 span {
  color: var(--lkfr-muted, #7b869d);
  font-size: 16px;
  font-weight: 400;
}
.salon-benchmark .benchmark-header p {
  margin: 0;
  font-size: 12px;
  color: var(--lkfr-muted, #7b869d);
  text-transform: capitalize;
}
.salon-benchmark .benchmark-header .lkfr-eyebrow {
  font-size: 10px;
}
.salon-benchmark .benchmark-symbol {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  flex-shrink: 0;
  color: var(--lkfr-accent, #ed2847);
  background: #fff0f3;
}
.salon-benchmark .benchmark-symbol svg {
  width: 32px;
  height: 32px;
}
.salon-benchmark .benchmark-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.salon-benchmark .benchmark-controls .benchmark-switch {
  flex: 1 1;
}
.salon-benchmark .benchmark-pro-toggle {
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid #e0e5ee;
  border-radius: 10px;
  background: white;
  color: #64718a;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.salon-benchmark .benchmark-pro-toggle[aria-pressed=true] {
  color: #d72543;
  border-color: #efc3cc;
  background: #fff0f3;
}
.salon-benchmark .benchmark-pro-toggle:focus-visible {
  outline: 2px solid var(--lkfr-accent, #ed2847);
  outline-offset: 2px;
}
.salon-benchmark .benchmark-switch {
  display: flex;
  background: #f3f5f8;
  padding: 3px;
  border-radius: 12px;
  margin: 16px 0 10px;
}
.salon-benchmark .benchmark-switch button {
  flex: 1 1;
  min-width: 0;
  min-height: 44px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--lkfr-muted, #7b869d);
  font-size: 13px;
}
.salon-benchmark .benchmark-switch button[aria-pressed=true] {
  background: white;
  color: var(--lkfr-ink, #252238);
  box-shadow: 0 1px 5px rgba(36, 50, 74, 0.0470588235);
  font-weight: 600;
}
.salon-benchmark .benchmark-switch button:focus-visible {
  outline: 2px solid var(--lkfr-accent, #ed2847);
}
.salon-benchmark .benchmark-context {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  font-size: 11px;
  color: var(--lkfr-muted, #7b869d);
  margin-bottom: 14px;
}
.salon-benchmark .benchmark-context span:last-child {
  margin-left: auto;
}
.salon-benchmark .benchmark-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.salon-benchmark .benchmark-metric {
  padding: 15px;
  border: 1px solid #edf0f5;
  border-radius: 14px;
  min-width: 0;
}
.salon-benchmark .benchmark-metric-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}
.salon-benchmark .benchmark-metric-title h3 {
  font-size: 13px;
  font-weight: 500;
  margin: 0;
}
.salon-benchmark .benchmark-delta {
  font-size: 11px;
  font-weight: 500;
  padding: 3px 6px;
  border-radius: 6px;
  white-space: nowrap;
}
.salon-benchmark .benchmark-delta.favorable {
  color: #237959;
  background: #eef7f3;
}
.salon-benchmark .benchmark-delta.unfavorable {
  color: #b67124;
  background: #fff6e9;
}
.salon-benchmark .benchmark-delta.neutral {
  color: #7b869d;
  background: #f4f5f8;
}
.salon-benchmark .benchmark-values {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
}
.salon-benchmark .benchmark-values small {
  font-size: 10px;
  color: var(--lkfr-muted, #7b869d);
  display: block;
}
.salon-benchmark .benchmark-values strong {
  display: block;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.salon-benchmark .benchmark-values div:last-child strong {
  font-weight: 500;
  color: #5c677b;
}
.salon-benchmark .benchmark-total {
  color: #64718a;
  font-size: 10px;
  margin: 7px 0 0;
}
.salon-benchmark .benchmark-distribution {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 14px 0 0;
  padding-top: 12px;
  border-top: 1px solid #edf0f5;
}
.salon-benchmark .benchmark-distribution div {
  min-width: 0;
}
.salon-benchmark .benchmark-distribution dt {
  color: #64718a;
  font-size: 10px;
  line-height: 1.5;
  font-weight: 400;
}
.salon-benchmark .benchmark-distribution dd {
  font-size: 14px;
  font-weight: 500;
  overflow-wrap: anywhere;
  margin: 4px 0 0;
}
.salon-benchmark .benchmark-position {
  background: #f5f7fa;
  border-radius: 10px;
  padding: 10px;
  margin-top: 12px;
}
.salon-benchmark .benchmark-position p {
  margin: 0;
  font-size: 12px;
}
.salon-benchmark .benchmark-position p strong {
  font-size: 15px;
}
.salon-benchmark .benchmark-position p + p {
  font-size: 10px;
  color: #64718a;
  margin-top: 4px;
}
.salon-benchmark .benchmark-band {
  position: relative;
  height: 6px;
  background: #f1f3f7;
  border-radius: 10px;
  margin: 14px 0 9px;
}
.salon-benchmark .benchmark-band span {
  position: absolute;
  top: 0;
}
.salon-benchmark .benchmark-band .benchmark-band-range {
  height: 6px;
  border-radius: 10px;
  background: #c7d3e4;
}
.salon-benchmark .benchmark-band .benchmark-band-median {
  width: 2px;
  height: 10px;
  top: -2px;
  background: #6c7d95;
}
.salon-benchmark .benchmark-band .benchmark-band-point {
  width: 12px;
  height: 12px;
  background: var(--lkfr-accent, #ed2847);
  top: -3px;
  border: 2px solid white;
  border-radius: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 0 1px rgba(237, 40, 71, 0.1411764706);
}
.salon-benchmark .benchmark-note, .salon-benchmark .benchmark-period, .salon-benchmark .benchmark-updated {
  font-size: 10px;
  color: var(--lkfr-muted, #7b869d);
  margin: 6px 0 0;
  overflow-wrap: anywhere;
}
.salon-benchmark .benchmark-period {
  margin-top: 14px;
}
.salon-benchmark .benchmark-updated {
  margin-top: 4px;
}
.salon-benchmark .benchmark-notice {
  font-size: 12px;
  background: #f6f7fa;
  border-radius: 10px;
  padding: 12px;
  color: #637088;
}
.salon-benchmark .benchmark-notice button {
  background: none;
  border: 0;
  color: var(--lkfr-accent, #ed2847);
  min-height: 44px;
  padding: 0 8px;
}
.salon-benchmark .benchmark-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  color: var(--lkfr-ink, #252238);
  font-size: 12px;
  padding-top: 13px;
  margin-top: 13px;
  border-top: 1px solid #edf0f5;
  min-height: 44px;
}
.salon-benchmark .benchmark-details span {
  color: var(--lkfr-muted, #7b869d);
}
.salon-benchmark .benchmark-method {
  margin-top: 16px;
  font-size: 12px;
  color: #64718a;
}
.salon-benchmark .benchmark-method summary {
  cursor: pointer;
  min-height: 44px;
  display: flex;
  align-items: center;
}
.salon-benchmark.is-summary {
  padding: 14px 0 0;
  margin: 14px 0 0;
  border: 0;
  border-top: 1px solid #edf0f5;
  border-radius: 0;
}
.salon-benchmark.is-summary .benchmark-header > div {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
}
.salon-benchmark.is-summary .benchmark-header > div h2 {
  margin: 0;
  font-size: 16px;
}
.salon-benchmark.is-summary .benchmark-header > div h2 span {
  font-size: 12px;
}
.salon-benchmark.is-summary .benchmark-header > div p {
  font-size: 11px;
}
.salon-benchmark.is-summary .benchmark-verdict {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 14px 0 10px;
}
.salon-benchmark.is-summary .benchmark-verdict > div {
  min-width: 0;
}
.salon-benchmark.is-summary .benchmark-verdict h3 {
  margin: 0;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.salon-benchmark.is-summary .benchmark-verdict p {
  margin: 5px 0 0;
  font-size: 12px;
  color: #64718a;
}
.salon-benchmark.is-summary .benchmark-verdict-icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #748198;
  background: #f2f4f8;
}
.salon-benchmark.is-summary .benchmark-verdict-icon svg {
  width: 23px;
  height: 23px;
}
.salon-benchmark.is-summary.verdict-positive .benchmark-verdict h3 {
  color: #237959;
}
.salon-benchmark.is-summary.verdict-positive .benchmark-verdict-icon {
  background: #eef7f3;
  color: #237959;
}
.salon-benchmark.is-summary.verdict-negative .benchmark-verdict h3 {
  color: #a66823;
}
.salon-benchmark.is-summary.verdict-negative .benchmark-verdict-icon {
  background: #fff6e9;
  color: #a66823;
}
.salon-benchmark.is-summary.verdict-unavailable .benchmark-verdict h3 {
  font-size: 18px;
}
.salon-benchmark.is-summary .benchmark-verdict-meta {
  color: #748198;
  font-size: 10px;
  margin: 0;
}
.salon-benchmark.is-summary .benchmark-updated {
  margin: 3px 0 0;
}
.salon-benchmark.is-summary .benchmark-verdict-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.salon-benchmark.is-summary .benchmark-more, .salon-benchmark.is-summary .benchmark-retry {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 44px;
  flex: 1 1;
  border: 1px solid #e0e5ee;
  border-radius: 11px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  color: var(--lkfr-ink, #252238);
  background: #f8f9fc;
}
.salon-benchmark.is-summary .benchmark-more:hover, .salon-benchmark.is-summary .benchmark-retry:hover {
  border-color: #c7d3e4;
}
.salon-benchmark.is-summary .benchmark-more:focus-visible, .salon-benchmark.is-summary .benchmark-retry:focus-visible {
  outline: 2px solid var(--lkfr-accent, #ed2847);
  outline-offset: 2px;
}

@media (max-width: 1000px) {
  .salon-benchmark .benchmark-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 650px) {
  .salon-benchmark {
    padding: 15px;
  }
  .salon-benchmark .benchmark-metrics {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .salon-benchmark .benchmark-metric {
    border: 0;
    border-radius: 0;
    padding: 14px 0;
    border-bottom: 1px solid #edf0f5;
  }
  .salon-benchmark .benchmark-metric:last-child {
    border: 0;
  }
  .salon-benchmark .benchmark-context span:last-child {
    margin-left: 0;
  }
  .salon-benchmark .benchmark-header h2 {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SalonBenchmark/salonBenchmark.scss"],"names":[],"mappings":"AAAA;EAAmB,YAAA;EAAc,6CAAA;EAA+C,mBAAA;EAAqB,gBAAA;EAAkB,aAAA;EAAe,+BAAA;EAAiC,cAAA;EAAgB,sBAAA;AASvL;AARI;EAAI,sBAAA;AAWR;AAXkC;EAAS,aAAA;EAAe,eAAA;AAe1D;AAf6E;EAAI,gBAAA;AAkBjF;AAjBI;EAAoB,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;AAuB5F;AAvBuG;EAAK,eAAA;EAAiB,aAAA;EAAe,gBAAA;AA4B5I;AA5B8J;EAAO,iCAAA;EAAmC,eAAA;EAAiB,gBAAA;AAiCzN;AAjC+O;EAAI,SAAA;EAAW,eAAA;EAAiB,iCAAA;EAAmC,0BAAA;AAuClT;AAvCgV;EAAgB,eAAA;AA0ChW;AAzCI;EAAoB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,cAAA;EAAgB,kCAAA;EAAoC,mBAAA;AAmDhK;AAnDqL;EAAM,WAAA;EAAa,YAAA;AAuDxM;AAtDI;EAAsB,aAAA;EAAe,mBAAA;EAAqB,QAAA;AA2D9D;AA3DwE;EAAoB,SAAA;AA8D5F;AA7DI;EAAwB,gBAAA;EAAkB,eAAA;EAAiB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAwErL;AAxEqM;EAAyB,cAAA;EAAgB,qBAAA;EAAuB,mBAAA;AA6ErQ;AA7E4R;EAAkB,8CAAA;EAAgD,mBAAA;AAiF9V;AAhFI;EAAoB,aAAA;EAAe,mBAAA;EAAqB,YAAA;EAAc,mBAAA;EAAqB,mBAAA;AAuF/F;AAvFoH;EAAS,SAAA;EAAS,YAAA;EAAc,gBAAA;EAAkB,SAAA;EAAW,kBAAA;EAAoB,uBAAA;EAAyB,iCAAA;EAAmC,eAAA;AAiGjQ;AAjGkR;EAAyB,iBAAA;EAAmB,+BAAA;EAAiC,oDAAA;EAAiC,gBAAA;AAuGhY;AAvGoZ;EAAkB,8CAAA;AA0Gta;AAzGI;EAAqB,aAAA;EAAe,eAAA;EAAiB,aAAA;EAAe,eAAA;EAAiB,iCAAA;EAAmC,mBAAA;AAiH5H;AAjHiJ;EAAkB,iBAAA;AAoHnK;AAnHI;EAAqB,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAwH1F;AAvHI;EAAoB,aAAA;EAAe,yBAAA;EAA2B,mBAAA;EAAqB,YAAA;AA6HvF;AA5HI;EAA0B,aAAA;EAAe,qBAAA;EAAuB,8BAAA;EAAgC,QAAA;EAAU,eAAA;AAmI9G;AAnI+H;EAAK,eAAA;EAAiB,gBAAA;EAAkB,SAAA;AAwIvK;AAvII;EAAmB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;AA8IhG;AA9IqH;EAAc,cAAA;EAAgB,mBAAA;AAkJnJ;AAlJ0K;EAAgB,cAAA;EAAgB,mBAAA;AAsJ1M;AAtJiO;EAAY,cAAA;EAAgB,mBAAA;AA0J7P;AAzJI;EAAoB,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,gBAAA;AA+JlF;AA/JoG;EAAQ,eAAA;EAAiB,iCAAA;EAAmC,cAAA;AAoKhK;AApKkL;EAAS,cAAA;EAAgB,eAAA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AA2K/P;AA3K0R;EAAwB,gBAAA;EAAkB,cAAA;AA+KpU;AA9KI;EAAmB,cAAA;EAAgB,eAAA;EAAiB,eAAA;AAmLxD;AAlLI;EAA0B,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,gBAAA;EAAkB,iBAAA;EAAmB,6BAAA;AA0L/I;AA1L8K;EAAM,YAAA;AA6LpL;AA7LoM;EAAK,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AAmM5P;AAnMgR;EAAK,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAyB,eAAA;AAyMjV;AAxMI;EAAsB,mBAAA;EAAqB,mBAAA;EAAqB,aAAA;EAAe,gBAAA;AA8MnF;AA9MqG;EAAI,SAAA;EAAW,eAAA;AAkNpH;AAlNqI;EAAS,eAAA;AAqN9I;AArNmK;EAAQ,eAAA;EAAiB,cAAA;EAAgB,eAAA;AA0N5M;AAzNI;EAAkB,kBAAA;EAAoB,WAAA;EAAa,mBAAA;EAAqB,mBAAA;EAAqB,kBAAA;AAgOjG;AAhOqH;EAAO,kBAAA;EAAoB,MAAA;AAoOhJ;AApO0J;EAAwB,WAAA;EAAa,mBAAA;EAAqB,mBAAA;AAyOpN;AAzO2O;EAAyB,UAAA;EAAY,YAAA;EAAc,SAAA;EAAW,mBAAA;AA+OzS;AA/OgU;EAAwB,WAAA;EAAa,YAAA;EAAc,uCAAA;EAAyC,SAAA;EAAW,uBAAA;EAAyB,kBAAA;EAAoB,2BAAA;EAA6B,qDAAA;AAyPjf;AAxPI;EAAyD,eAAA;EAAiB,iCAAA;EAAmC,eAAA;EAAiB,uBAAA;AA8PlI;AA7PI;EAAoB,gBAAA;AAgQxB;AAhQ4C;EAAqB,eAAA;AAmQjE;AAlQI;EAAoB,eAAA;EAAiB,mBAAA;EAAqB,mBAAA;EAAqB,aAAA;EAAe,cAAA;AAyQlG;AAzQkH;EAAS,gBAAA;EAAkB,SAAA;EAAW,kCAAA;EAAoC,gBAAA;EAAkB,cAAA;AAgR9M;AA/QI;EAAqB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,qBAAA;EAAuB,+BAAA;EAAiC,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;EAAkB,6BAAA;EAA+B,gBAAA;AA2R1O;AA3R4P;EAAO,iCAAA;AA8RnQ;AA7RI;EAAoB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAkS3D;AAlS2E;EAAU,eAAA;EAAiB,gBAAA;EAAkB,aAAA;EAAe,mBAAA;AAwSvI;AAvSI;EACI,iBAAA;EAAmB,gBAAA;EAAkB,SAAA;EAAW,6BAAA;EAA+B,gBAAA;AA6SvF;AA5SQ;EAA0B,aAAA;EAAe,qBAAA;EAAuB,8BAAA;EAAgC,QAAA;EAAU,eAAA;EAAiB,WAAA;AAoTnI;AApTgJ;EAAK,SAAA;EAAW,eAAA;AAwThK;AAxTiL;EAAO,eAAA;AA2TxL;AA3T6M;EAAI,eAAA;AA8TjN;AA7TQ;EAAqB,aAAA;EAAe,uBAAA;EAAyB,SAAA;EAAW,mBAAA;AAmUhF;AAnUqG;EAAQ,YAAA;AAsU7G;AAtU6H;EAAK,SAAA;EAAW,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;EAAkB,uBAAA;AA6UnM;AA7U8N;EAAI,eAAA;EAAiB,eAAA;EAAiB,cAAA;AAkVpQ;AAjVQ;EAA0B,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;EAAgB,mBAAA;AA2VtJ;AA3V2K;EAAM,WAAA;EAAa,YAAA;AA+V9L;AA9V6B;EAAwB,cAAA;AAiWrD;AAjWuE;EAA0B,mBAAA;EAAqB,cAAA;AAqWtH;AApW6B;EAAwB,cAAA;AAuWrD;AAvWuE;EAA0B,mBAAA;EAAqB,cAAA;AA2WtH;AA1WQ;EAA8C,eAAA;AA6WtD;AA5WQ;EAA0B,cAAA;EAAgB,eAAA;EAAiB,SAAA;AAiXnE;AAhXQ;EAAqB,eAAA;AAmX7B;AAlXQ;EAA6B,aAAA;EAAe,QAAA;EAAU,gBAAA;AAuX9D;AAtXQ;EAAoC,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,SAAA;EAAW,gBAAA;EAAkB,SAAA;EAAS,yBAAA;EAA2B,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,qBAAA;EAAuB,+BAAA;EAAiC,mBAAA;AAqY1R;AArY+S;EAAU,qBAAA;AAwYzT;AAxYkV;EAAkB,8CAAA;EAAgD,mBAAA;AA4YpZ;;AAxYA;EAA4B;IAAsC,gDAAA;EA6YhE;AACF;AA7YA;EAA2B;IAAmB,aAAA;EAiZ5C;EAjZ2D;IAAqB,0BAAA;IAA4B,MAAA;EAqZ5G;EArZsH;IAAoB,SAAA;IAAW,gBAAA;IAAkB,eAAA;IAAiB,gCAAA;EA2ZxL;EA3Z0N;IAAe,SAAA;EA8ZzO;EA9ZwP;IAAqC,cAAA;EAia7R;EAja+S;IAAuB,eAAA;EAoatU;AACF","sourcesContent":[".salon-benchmark { min-width: 0; border: 1px solid var(--lkfr-border, #e0e5ee); border-radius: 18px; background: #fff; padding: 20px; color: var(--lkfr-ink, #252238); margin: 18px 0; box-sizing: border-box;\n    * { box-sizing: border-box; } button { font: inherit; cursor: pointer; } p { line-height: 1.5; }\n    .benchmark-header { display: flex; justify-content: space-between; align-items: center; gap: 12px; h2 { font-size: 22px; margin: 6px 0; font-weight: 600; span { color: var(--lkfr-muted, #7b869d); font-size: 16px; font-weight: 400; } } p { margin: 0; font-size: 12px; color: var(--lkfr-muted, #7b869d); text-transform: capitalize; } .lkfr-eyebrow { font-size: 10px; } }\n    .benchmark-symbol { display: grid; place-items: center; width: 44px; height: 44px; border-radius: 14px; flex-shrink: 0; color: var(--lkfr-accent, #ed2847); background: #fff0f3; svg { width: 32px; height: 32px; } }\n    .benchmark-controls { display: flex; align-items: center; gap: 8px; .benchmark-switch { flex: 1; } }\n    .benchmark-pro-toggle { min-height: 44px; padding: 0 12px; border: 1px solid #e0e5ee; border-radius: 10px; background: white; color: #64718a; font-size: 12px; font-weight: 600; flex-shrink: 0; &[aria-pressed=\"true\"] { color: #d72543; border-color: #efc3cc; background: #fff0f3; } &:focus-visible { outline: 2px solid var(--lkfr-accent, #ed2847); outline-offset: 2px; } }\n    .benchmark-switch { display: flex; background: #f3f5f8; padding: 3px; border-radius: 12px; margin: 16px 0 10px; button { flex: 1; min-width: 0; min-height: 44px; border: 0; border-radius: 9px; background: transparent; color: var(--lkfr-muted, #7b869d); font-size: 13px; &[aria-pressed=\"true\"] { background: white; color: var(--lkfr-ink, #252238); box-shadow: 0 1px 5px #24324a0c; font-weight: 600; } &:focus-visible { outline: 2px solid var(--lkfr-accent, #ed2847); } } }\n    .benchmark-context { display: flex; flex-wrap: wrap; gap: 6px 12px; font-size: 11px; color: var(--lkfr-muted, #7b869d); margin-bottom: 14px; span:last-child { margin-left: auto; } }\n    .benchmark-metrics { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }\n    .benchmark-metric { padding: 15px; border: 1px solid #edf0f5; border-radius: 14px; min-width: 0; }\n    .benchmark-metric-title { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; flex-wrap: wrap; h3 { font-size: 13px; font-weight: 500; margin: 0; } }\n    .benchmark-delta { font-size: 11px; font-weight: 500; padding: 3px 6px; border-radius: 6px; white-space: nowrap; &.favorable { color: #237959; background: #eef7f3; } &.unfavorable { color: #b67124; background: #fff6e9; } &.neutral { color: #7b869d; background: #f4f5f8; } }\n    .benchmark-values { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 12px; small { font-size: 10px; color: var(--lkfr-muted, #7b869d); display: block; } strong { display: block; margin-top: 4px; font-size: 18px; font-weight: 600; overflow-wrap: anywhere; } div:last-child strong { font-weight: 500; color: #5c677b; } }\n    .benchmark-total { color: #64718a; font-size: 10px; margin: 7px 0 0; }\n    .benchmark-distribution { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin: 14px 0 0; padding-top: 12px; border-top: 1px solid #edf0f5; div { min-width: 0; } dt { color: #64718a; font-size: 10px; line-height: 1.5; font-weight: 400; } dd { font-size: 14px; font-weight: 500; overflow-wrap: anywhere; margin: 4px 0 0; } }\n    .benchmark-position { background: #f5f7fa; border-radius: 10px; padding: 10px; margin-top: 12px; p { margin: 0; font-size: 12px; strong { font-size: 15px; } } p + p { font-size: 10px; color: #64718a; margin-top: 4px; } }\n    .benchmark-band { position: relative; height: 6px; background: #f1f3f7; border-radius: 10px; margin: 14px 0 9px; span { position: absolute; top: 0; } .benchmark-band-range { height: 6px; border-radius: 10px; background: #c7d3e4; } .benchmark-band-median { width: 2px; height: 10px; top: -2px; background: #6c7d95; } .benchmark-band-point { width: 12px; height: 12px; background: var(--lkfr-accent, #ed2847); top: -3px; border: 2px solid white; border-radius: 50%; transform: translateX(-50%); box-shadow: 0 0 0 1px #ed284724; } }\n    .benchmark-note, .benchmark-period, .benchmark-updated { font-size: 10px; color: var(--lkfr-muted, #7b869d); margin: 6px 0 0; overflow-wrap: anywhere; }\n    .benchmark-period { margin-top: 14px; } .benchmark-updated { margin-top: 4px; }\n    .benchmark-notice { font-size: 12px; background: #f6f7fa; border-radius: 10px; padding: 12px; color: #637088; button { background: none; border: 0; color: var(--lkfr-accent, #ed2847); min-height: 44px; padding: 0 8px; } }\n    .benchmark-details { display: flex; align-items: center; justify-content: space-between; text-decoration: none; color: var(--lkfr-ink, #252238); font-size: 12px; padding-top: 13px; margin-top: 13px; border-top: 1px solid #edf0f5; min-height: 44px; span { color: var(--lkfr-muted, #7b869d); } }\n    .benchmark-method { margin-top: 16px; font-size: 12px; color: #64718a; summary { cursor: pointer; min-height: 44px; display: flex; align-items: center; } }\n    &.is-summary {\n        padding: 14px 0 0; margin: 14px 0 0; border: 0; border-top: 1px solid #edf0f5; border-radius: 0;\n        .benchmark-header > div { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; flex-wrap: wrap; width: 100%; h2 { margin: 0; font-size: 16px; span { font-size: 12px; } } p { font-size: 11px; } }\n        .benchmark-verdict { display: flex; align-items: flex-start; gap: 12px; margin: 14px 0 10px; > div { min-width: 0; } h3 { margin: 0; font-size: 24px; line-height: 1.25; font-weight: 600; overflow-wrap: anywhere; } p { margin: 5px 0 0; font-size: 12px; color: #64718a; } }\n        .benchmark-verdict-icon { width: 38px; height: 38px; flex-shrink: 0; display: grid; place-items: center; border-radius: 12px; color: #748198; background: #f2f4f8; svg { width: 23px; height: 23px; } }\n        &.verdict-positive { .benchmark-verdict h3 { color: #237959; } .benchmark-verdict-icon { background: #eef7f3; color: #237959; } }\n        &.verdict-negative { .benchmark-verdict h3 { color: #a66823; } .benchmark-verdict-icon { background: #fff6e9; color: #a66823; } }\n        &.verdict-unavailable .benchmark-verdict h3 { font-size: 18px; }\n        .benchmark-verdict-meta { color: #748198; font-size: 10px; margin: 0; }\n        .benchmark-updated { margin: 3px 0 0; }\n        .benchmark-verdict-actions { display: flex; gap: 8px; margin-top: 12px; }\n        .benchmark-more, .benchmark-retry { display: flex; align-items: center; justify-content: center; gap: 10px; min-height: 44px; flex: 1; border: 1px solid #e0e5ee; border-radius: 11px; font-size: 12px; font-weight: 500; text-decoration: none; color: var(--lkfr-ink, #252238); background: #f8f9fc; &:hover { border-color: #c7d3e4; } &:focus-visible { outline: 2px solid var(--lkfr-accent, #ed2847); outline-offset: 2px; } }\n    }\n\n}\n@media(max-width: 1000px) { .salon-benchmark .benchmark-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n@media(max-width: 650px) { .salon-benchmark { padding: 15px; .benchmark-metrics { grid-template-columns: 1fr; gap: 0; } .benchmark-metric { border: 0; border-radius: 0; padding: 14px 0; border-bottom: 1px solid #edf0f5; &:last-child { border: 0; } } .benchmark-context span:last-child { margin-left: 0; } .benchmark-header h2 { font-size: 20px; } } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
